import _ from 'lodash';
import { BrowserBarcodeReader } from '@zxing/library';

const codeReader = new BrowserBarcodeReader();

export const getAvailableDevices = (onFinishingConfiguration) => {
  codeReader.getVideoInputDevices().then((devices) => {
    const { deviceId } = _.first(devices);
    if (deviceId) {
      onFinishingConfiguration(deviceId);
    }
  });

  return codeReader;
};

export const waitForBarcode = (onScan, deviceId) => {
  codeReader.decodeOnceFromVideoDevice(deviceId, 'video').then((result) => {
    onScan(result);
    waitForBarcode(onScan, deviceId);
  }).catch((err) => {
    console.log('error', err);
  });
};

export const startBarcodeScanner = (onScan) => {
  const onFinishingConfiguration = (deviceId) => {
    if (!deviceId) return;
    waitForBarcode(onScan, deviceId);
  };

  getAvailableDevices(onFinishingConfiguration);
};

export const stopBarcodeScanner = () => {
  codeReader.reset();
};
